export enum InMailTypeEnum {
  Bid,
  Offer,
}
